import { Component } from '@angular/core';
import { BaseDetailPageComponent } from 'src/app/components/pages/base-detail-page/base-detail-page.component';
import BaseDetailPageConfig from 'src/app/models/base-detail-page.config';
import { ProjectsService } from 'src/app/services/api/projects.service';
import { CommonService } from 'src/app/services/common.service';
import { RouteService } from 'src/app/services/route.service';

@Component({
  selector: 'app-projects-testlist-detail-page',
  imports: [BaseDetailPageComponent],
  templateUrl: './projects-testlist-detail-page.component.html',
  styleUrl: './projects-testlist-detail-page.component.scss'
})
export class ProjectsTestlistDetailPageComponent {
  baseDetailPageConfig!: BaseDetailPageConfig;
  readonlyTestlistDetail: boolean

  testlist?: any;

  constructor(
    private projectsService: ProjectsService,
    private routeService: RouteService,
    private commonService: CommonService
  ) {
    this.readonlyTestlistDetail = true
  }

  ngOnInit(): void {

    this.baseDetailPageConfig = {
      pageTitle: 'Testlist',
      cardTitle: 'Testlist Detail',
      editItemButton: {
        type: 'success',
        title: 'Edit Testlist',
        onClick: () => {
          this.routeService.projectsSettingsTestlistUpdate(this.testlist?.testlistId)
        }
      },
      dataList: {
        data: null,
        rows: [
          {
            attribute: 'Id',
            label: 'ID',
            value: (item: any) => {
              return item.testlistId;
            }
          },
          {
            attribute: 'name',
            label: 'Name',
            value: (item: any) => {
              return item.name;
            }
          },          
          {
            attribute: 'estimated_time',
            label: 'Estimated Time',
            value: (item: any) => {          
                if (typeof item.estimatedTime !== 'number' || isNaN(item.estimatedTime)) return '';
                const minutes = item.estimatedTime;
                if (minutes < 60) {
                  return `${minutes} min`;
                }
                const h = Math.floor(minutes / 60);
                const m = minutes % 60;
                const formatted = m === 0 ? `${h}:00` : `${h}:${m.toString().padStart(2, '0')}`;
                return `${formatted} h`;
              }
              },
              {
              attribute: 'createTime',
              label: 'Create Time',
              value: (item: any) => {
              return this.formatCreateTime(item.createTime);
            }
          },
        ]
      },
      apiDetailService: (testlistId: any) => this.projectsService.detailSettingsTestlist(testlistId),
      routeParamName: 'testlistId',
      responseModelName: 'testlist'
    };

  }

  onLoadedDetail(data: any) {
    this.testlist = data;
  }

  private formatCreateTime(date: any): string {
    if (!date) return '';
    
    try {
      const dateObj = typeof date === 'string' ? new Date(date) : date;
      
      if (!(dateObj instanceof Date) || isNaN(dateObj.getTime())) {
        return '';
      }
      return this.commonService.formatDate(dateObj);
    } catch (error) {
      console.warn('Errore nella formattazione della data:', error);
      return '';
    }
  }
}
